import { apiProvider } from './api';
import { NAME } from './constants';
import { router } from './router';

export const EventFrequency = {
	name: NAME,
	apiProvider,
	router,
};
